/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Logger } from '../logger';
import { Request } from '../request';

export class BeaconRequest implements Request {
  constructor(private url: string) {}

  public isAvailable(): boolean {
    return typeof navigator !== 'undefined' && typeof navigator.sendBeacon !== 'undefined';
  }

  public send(data: string | Uint8Array): boolean {
    Logger.info('send by beacon');

    let type = 'text/plain; charset=UTF-8';

    if (Object.prototype.toString.call(data) !== '[object String]') {
      type = 'application/octet-stream';
    }

    // Hack for Chrome: use text/plain, see: http://crbug.com/490015 for details.
    return navigator.sendBeacon(this.url, new Blob([data], { type: type }));
  }
}
